import request from '@/utils/request2'

// 列表(主数据列表)
export function loadActivityReportImageChangeRecordListDataApi(data) {
  return request({
    url: 'tms-web/activityReportImageChangeRecord/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportActivityReportImageChangeRecordListDataApi(data) {
  return request({
    url: 'tms-web/activityReportImageChangeRecord/exportByPage',
    method: 'post',
    data
  })
}

// 查看
export function viewActivityReportImageChangeRecordApi(data) {
  return request({
    url: 'tms-web/activityReportImageChangeRecord/view',
    method: 'post',
    data
  })
}